module.exports = __webpack_public_path__ + "img/web.4955e2.png";